import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { XdrSearchDataProviderFactory } from '../factory/XdrSearchDataProviderFactory';
import { XdrSearchBaseDataProvider } from '../dataProvider/XdrSearchBaseDataProvider';
import { XdrSearchWebComponentSchema } from '../types';

export class XdrSearchRepository extends BaseWebComponentRepository {
  public dataProviderFactory: XdrSearchDataProviderFactory;
  public dataProvider: XdrSearchBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new XdrSearchDataProviderFactory(),
    });
  }

  async getDataForView(): Promise<XdrSearchWebComponentSchema> {
    return this.dataProvider.getDataForView();
  }
}
